import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    data: []
};
function processResource(data) {
    return {
        id: data.id,
        name: data.name,
        number: data.number,
        command: data.command,
        statuses: data.statuses,
        category: data.category
    };
}
export var ProcessReducer = createSlice({
    name: 'process',
    initialState: initialState,
    reducers: {
        set: function set(state, payloadAction) {
            var data = [];
            payloadAction.payload.forEach(function (item) {
                data[item.id] = processResource(item);
            });
            state.data = data;
        },
        add: function add(state, payloadAction) {
            var process = processResource(payloadAction.payload);
            state.data[process.id] = payloadAction.payload;
        },
        del: function del(state, payloadAction) {
            state.data = state.data.filter(function (item) {
                return item.id !== payloadAction.payload;
            });
        },
        update: function update(state, payloadAction) {
            var updatedProcesses = payloadAction.payload.map(function (item) {
                return processResource(item);
            });
            var processes = state.data.map(function (item) {
                var comparedItem = updatedProcesses.find(function (unit) {
                    return unit.id === item.id;
                });
                return Boolean(comparedItem) ? comparedItem : item;
            });
            state.data = state.data.filter(function (item) {
                var comparedProcess = processes.find(function (process) {
                    return (item === null || item === void 0 ? void 0 : item.id) === (process === null || process === void 0 ? void 0 : process.id);
                });
                if (!comparedProcess)
                    return true;
                return comparedProcess.category.value === item.category.value;
            }).map(function (item) {
                var comparedItem = updatedProcesses.find(function (unit) {
                    return unit.id === item.id;
                });
                return Boolean(comparedItem) ? comparedItem : item;
            });
        }
    }
});
var _ProcessReducer$actio = ProcessReducer.actions, add = _ProcessReducer$actio.add, set = _ProcessReducer$actio.set, del = _ProcessReducer$actio.del, update = _ProcessReducer$actio.update;
export { add, set, del, update };
export default ProcessReducer.reducer;
